import { mapPayments } from "./paymentMapper";

export const mapConsumerInvoiceSale = (formData: any) => {
  return {
    saleId: formData.id ?? null, // ← si el backend lo requiere, de lo contrario elimínalo
    branch: formData.branch ?? null, // ← opcional, si lo ocupás en backend
    customer: formData.customer ?? null, // ← opcional, si aplica
    documentType: formData.documentType ?? null,
    saleDate: formData.saleDate,
    paymentCondition: formData.paymentCondition ?? null,
    // paymentMethod: formData.paymentMethod ?? null,
    // individualPayments: formData.individualPayments || {},
    payments: mapPayments(formData.payments),
    comments: formData.comments || null,
  };
};
